import Flex from '@Components/Bases/Flex';
import { useGetFinancialStatement } from '@Domains/FinancialStatements';
import { Alert, Box, CircularProgress } from '@mui/material';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

const DownloadFile = () => {
  const { id, lang, year } = useParams<{
    id: string;
    lang: string;
    year: string;
  }>();
  const [{ data, loading, error }] = useGetFinancialStatement(
    Number(id),
    lang,
    year
  );

  useEffect(() => {
    if (!data) return;

    const blob = new Blob([data], { type: 'application/zip' });

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `financial-statement-${id}.zip`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);

    window.URL.revokeObjectURL(url);

    window.close();
  }, [data]);

  if (loading) {
    return (
      <Flex justifyContent="center" alignItems="center" height="100vh">
        <CircularProgress size={50} />
      </Flex>
    );
  }

  if (error) {
    return (
      <Box p={2}>
        <Alert severity={'error'}>
          ไม่สามารถดาวน์โหลดแบบแสดงรายการข้อมูลประจำปี/รายงานประจำปี แบบ 56-1
          One Report ได้
        </Alert>
      </Box>
    );
  }

  return null;
};

export default DownloadFile;
